module.exports = __webpack_public_path__ + "static/media/01. JAKARTA_EMBASSY_OF_SWEDEN_RGB.dbfb8cdd.png";